import { ChangeEvent } from 'react';
import { FilterParams } from '@synergy/models';
import { FormattedMessage } from 'react-intl';
import { PoolTextField, useFilter } from '@synergy/components';
import { getCurrencySymbol } from '@synergy/utils';

import { bestLocaleSelector } from '../../selectors/locale-selectors';
import { useAppSelector } from '../../../store/use-appstate-selector';

export const MinPriceFilter = () => {
    const { filter, updateFilter, registerFilterMap } = useFilter();
    const { currency } = useAppSelector(state => state.settings);
    const locale = useAppSelector(state => bestLocaleSelector(state));
    const currencySymbol = getCurrencySymbol(currency, locale);

    const handleChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const minPrice: number = +event.target.value;
        filter.delete(FilterParams.MinPrice);
        if (!isNaN(minPrice)) {
            filter.set(FilterParams.MinPrice, minPrice.toString());
        }
        updateFilter(filter);
    };

    registerFilterMap(FilterParams.MinPrice, value => `${value} ${currencySymbol}`);

    return (
        <PoolTextField
            fullWidth={true}
            label={<FormattedMessage id="app.label.minPrice" />}
            value={filter.get(FilterParams.MinPrice)}
            onChange={handleChange}
            isNumeric={true}
            endAdornment={currencySymbol}
        />
    );
};
